import Immutable from "seamless-immutable";
import * as actionTypes from "./actionTypes";

const initialState = Immutable({
  byId: {},
  params: {},
  error: {},
  actionsloading: false,
  isSave:false
});

export function learningGoalsPDFReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SAVE_LG_PDF:
      return {
        ...state,
        byId: {},
        actionsloading: true,
        isSave:true
      };
    case actionTypes.SAVE_LG_PDF_SUCCESS:
      return {
        ...state,
        byId: action.payload.byId || {},
        params: action.payload.params || {},
        actionsloading: false,
        isSave:false
      };
    default:
      return state;
  }
}
